import { useState, useEffect } from "react";
import { Trash2 } from "lucide-react";
import {
  Dialog,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogTrigger,
  DialogDescription,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import t from "@/lang/lang";
import { useBusinessCentralMatchOneToOneDeleteMutation } from "@/services/backend/business-central/api/match-one-to-one-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { MatchType } from "@/services/backend/business-central/types/match-type";

export function MatchOneToOneDeleteDialog({
  type,
  id,
}: {
  type: MatchType;
  id: string;
}) {
  const [open, setOpen] = useState(false);
  const [put, { isLoading, error, isSuccess, reset }] =
    useBusinessCentralMatchOneToOneDeleteMutation();

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
    }
  }, [isSuccess, reset]);

  const doDelete = () => {
    if (isLoading) return;
    put({ type, id });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive">
          <Trash2 />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Zuordnung löschen")}</DialogTitle>
          <DialogDescription>
            {t("Möchten Sie diese Zuordnung wirklich löschen?")}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
